<app-category-path-component 
[categories]="categories">
</app-category-path-component>